import { ArrowLeft, Play } from "lucide-react";
import { useEffect, useState } from "react";

import { api } from "../api/client";
import type { PlaybackContinue } from "../api/types";
import { CommandButton } from "../components/CommandButton";
import { PageShell } from "../components/PageShell";
import {
  DEFAULT_ERROR_RECOVERY_ACTION,
  StatusBlock,
} from "../components/StatusBlock";
import { useAudioCoordinator } from "../stores/audioCoordinator";
import { useNavigationStore } from "../stores/navigationStore";
import styles from "../styles/App.module.css";

export function RecentPage() {
  const back = useNavigationStore((state) => state.back);
  const play = useAudioCoordinator((state) => state.play);
  const [positions, setPositions] = useState<PlaybackContinue[]>([]);
  const [recentLoaded, setRecentLoaded] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .recentPositions()
      .then((result) => {
        setPositions(result.items);
        setRecentLoaded(true);
      })
      .catch((loadError) => {
        setError(
          loadError instanceof Error ? loadError.message : "读取最近播放失败。",
        );
        setRecentLoaded(true);
      });
  }, []);

  return (
    <PageShell title="最近听过" where="最近听过页">
      {error ? (
        <StatusBlock
          tone="error"
          message={error}
          recoveryAction={DEFAULT_ERROR_RECOVERY_ACTION}
        />
      ) : null}
      {!error && !recentLoaded ? (
        <StatusBlock message="正在读取最近播放。" />
      ) : null}
      {!error && recentLoaded && !positions.length ? (
        <StatusBlock message="还没有最近播放。播放戏曲或评书后会出现在这里。" />
      ) : null}
      <div className={styles.commandList}>
        {positions.map((position, index) => (
          <CommandButton
            key={`${position.content_type}-${position.episode_id}`}
            icon={Play}
            title={`播放：${position.title}`}
            hint={`第 ${index + 1} 项，共 ${positions.length} 项，从 ${Math.floor(
              position.position_seconds,
            )} 秒继续`}
            onClick={() => {
              void play({
                title: position.title,
                episodeId: position.episode_id,
                seriesId: position.series_id,
                contentType: position.content_type,
                startAtSeconds: position.position_seconds,
                grant: () => api.mediaGrant(position.episode_id),
              });
            }}
          />
        ))}
        <CommandButton
          icon={ArrowLeft}
          title="最近听过列表末尾，返回上一层"
          hint="这是最后一个最近播放操作，双击返回上一层"
          onClick={back}
        />
      </div>
    </PageShell>
  );
}
